import { useKeycloak } from 'all-in-one-react-keycloak';
import { PrincipalMemberProps } from 'contexts/claimProperties';

interface IUseKeycloakReady {
  ready: boolean;
  token: string | undefined;
  tokenParsed: PrincipalMemberProps | undefined; // Note(Andy Chow): keycloak.tokenParsed does not include memberType field by default => cast it temporarily
  keycloak: ReturnType<typeof useKeycloak>['keycloak'];
  initialized: boolean;
}

export const useKeycloakReady = (): IUseKeycloakReady => {
  const { keycloak, initialized } = useKeycloak();

  return {
    ready: initialized && !!keycloak.authenticated && !!keycloak.token,
    token: keycloak.token,
    tokenParsed: keycloak.tokenParsed as PrincipalMemberProps,
    keycloak,
    initialized,
  };
};
